import React from 'react';
import { LandingSection } from '../components/landing/LandingSection';
import { Advantages } from '../components/landing/Advantages';
import { VideoSection } from '../components/landing/VideoSection';
import { Services } from '../components/landing/Services';
import { HowItWorks } from '../components/landing/HowItWorks';
import { LatestProducts } from '../components/landing/LatestProducts';
import { FAQ } from '../components/landing/FAQ';
import { Footer } from '../components/landing/Footer';

const LandingPage = () => (
    <main className="snap-y snap-mandatory scroll-smooth">
        <LandingSection />
        <Advantages />
        <VideoSection />
        <Services />
        <HowItWorks />
        <LatestProducts />
        <FAQ />
        <Footer />
    </main>
);

export default LandingPage;